import { store, getContext, getElement } from "@wordpress/interactivity";
import axios from "axios";
import fileDownload from "js-file-download";
import { ceil, isFinite } from "lodash-es";
import { Fancybox } from '@fancyapps/ui/';
import { toNumber, isEmpty, set, clone } from 'lodash-es';
import * as focusTrap from 'focus-trap';
import { setup as setupComponents } from './components';
import { flatten } from 'flat'

let focusTrapInstance: focusTrap.FocusTrap|null = null;

// There is a tabindex issue with the built in focustrap in Fancybox when dynamically showing and hiding form elements,
// so we use the focus-trap package to set it up on our own instead.

(Fancybox as any).bind('[data-site-purchase-calculator-fancybox]', {
	trapFocus: false,
	backdropClick: false,
	on: {
		reveal: (fancybox, slide) => {
			if (focusTrapInstance) {
				focusTrapInstance.updateContainerElements(fancybox.container);
			}

			if (!focusTrapInstance) {
				focusTrapInstance = focusTrap.createFocusTrap(fancybox.container);
			}

			focusTrapInstance.activate();
		},
		close: (fancybox, slide) => {
			if (focusTrapInstance) {
				focusTrapInstance.deactivate();
			}
		},
	},
});

function selectVariation(variationId) {
	const $form = jQuery('.variations_form');

	if (!$form.length) {
			console.error('WooCommerce variations form not found.');
			return;
	}

	// Get all variations data from the form
	const variations = $form.data('product_variations');

	if (!variations) {
			console.error('No variations found for this product.');
			return;
	}

	// Reset variations before setting a new one
	$form.find( '.variations select' ).val( '' ).trigger( 'change' );

	// Find the variation by ID
	const variation = variations.find(variation => variation.variation_id === variationId);

	if (!variation) {
			console.error('Variation with the given ID not found.');
			return;
	}

	// Set the attributes corresponding to the variation
	for (const [attributeName, attributeValue] of Object.entries(variation.attributes)) {
			const $select = $form.find(`[name="${attributeName}"]`);
			// $select.val(attributeValue as string).trigger('change');
			$select.val(attributeValue as string);
	}

	// Trigger WooCommerce's variation change event
	$form.trigger('check_variations');
}

/*
document.addEventListener(
	"DOMContentLoaded",
	() => {
		window.setTimeout(() => {
			var clickEvent = new MouseEvent("click", {
				"view": window,
				"bubbles": true,
				"cancelable": false
			});

			document.querySelector('#open-purchase-calculator-button')?.dispatchEvent(clickEvent);
		}, 500)
	}
)
*/
interface Product {
	// Static (will not change)
	name: string;
	productNumber: string;
	nobbNumber: string;
	type: "per-panel"
		| "per-panel-inc-shrinkage"
		| "per-square-meter"
		| "per-square-meter-inc-shrinkage"
		| "per-meter"
		| "per-meter-inc-shrinkage"
		| "fixed"
		| "per-meter-trun-area"
		| "per-meter-trun-area-inc-shrinkage"
		| "per-square-meter-thermo-area"
		| "per-square-meter-thermo-area-inc-shrinkage"
		| "per-square-meter-turn-area"
		| "per-square-meter-turn-area-inc-shrinkage";
	amountInPackage: number;
	packageUnit: string;
	packageUnits: string;
	amountPerPanel?: number;
	amountPerMeter?: number;
	amountPerSquareMeter?: number;
	amountFixed?: number;
	displayDimensions?: string;
	weight: number;
	width?: number;
	length?: number;
	height?: number;
	// Dynamic (might change)
	quantity: number;
	quantityFormatted: string;
	unit: string;
	displayWeight: string;
}

type Products = Product[];

interface Collection {
	product_id: number;
	items: Products;
	panelWidth: number;
	panelLength: number;
	panelHeight: number;
	hasTurntable: boolean;
}

interface FormValues {
	roomType?: 'rectangular' | 'l-shaped' | 'u-shaped' | null,
	needTurntable?: 'yes' | 'no' | null,
	extraThermofloor?: string | null,
	lengthA?: string | null,
	lengthB?: string | null,
	lengthC?: string | null,
	lengthD?: string | null,
	lengthE?: string | null,
	lengthNextStep?: 'yes' | null,
	pipeLayingDirection?: 'vertical' | 'horizontal' | null,
}

interface BlockInitialState {
	isOpen: boolean;
	numRoomLength: number;
	numRoomLengthIncludingShrinkage: number;
	numSquareMeter: number;
	numSquareMeterIncludingShrinkage: number;
	numPanels: number;
	numPanelsIncludingShrinkage: number;
	restUrlBase: string;
	products: Products;
	productId: number;
	calculatorType: 'ceiling' | 'wall' | 'floor' | 'thermo_floor';
	items: Products;
	shrinkagePercentage: number;
	panelWidth: number;
	panelLength: number;
	panelHeight: number;
	hasTurntable: boolean;
	isLoading: boolean;
	deliveryType: 'download' | 'email';
	email: string;
	isDeliveryTypeDownload: boolean;
	isDeliveryTypeEmail: boolean;
	collections: Collection[];
	validationMessage: string;
	validationErrors: {[key:string]: string};
	successMessage: string;
	formValues: FormValues;
	oldFormValues: FormValues;
	formChecks: {[key:string]: boolean | object};
}

const meterNumberFormat = new Intl.NumberFormat("nb-NO", {
	style: "unit",
	unit: "meter",
	unitDisplay: "short",
});

const milliMeterNumberFormat = new Intl.NumberFormat("nb-NO", {
	style: "unit",
	unit: "millimeter",
	unitDisplay: "short",
});

const percentageNumberFormat = new Intl.NumberFormat("nb-NO", {
	style: "unit",
	unit: "percent",
	unitDisplay: "short",
});

const squareMeterNumberFormat = new Intl.NumberFormat("nb-NO", {
	style: "decimal",
	minimumIntegerDigits: 1,
	minimumFractionDigits: 0,
	maximumFractionDigits: 1,
});

const kgNumberFormat = new Intl.NumberFormat("nb-NO", {
	style: "unit",
	unit: "kilogram",
	minimumIntegerDigits: 1,
	minimumFractionDigits: 0,
	maximumFractionDigits: 2,
});

const gNumberFormat = new Intl.NumberFormat("nb-NO", {
	style: "unit",
	unit: "gram",
	minimumIntegerDigits: 1,
	minimumFractionDigits: 0,
	maximumFractionDigits: 2,
});

const quantityNumberFormat = new Intl.NumberFormat("nb-NO", {
	style: "decimal",
	minimumIntegerDigits: 1,
	minimumFractionDigits: 0,
	maximumFractionDigits: 1,
});

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block: HTMLDivElement) {
	if (!block.dataset.wpInteractive) {
		return;
	}

	const storeNamespace = block.dataset.wpInteractive;

	setupComponents(storeNamespace);

	const validate = (element: HTMLInputElement) => {
		// Check input validity
		if ("0" === element.value) {
			element.setCustomValidity("Verdien må være større enn 0.");
		} else {
			element.setCustomValidity("");
		}
	};

	const getAmountFromEvent = (event: any) => {
		const inputAmount: string = (event.target as HTMLInputElement).value;
		const amount: number = !inputAmount
			? 0
			: inputAmount.includes(".")
				? parseFloat(inputAmount)
				: parseInt(inputAmount);

		return amount;
	};

	function prepareStateItems(state) {
		state.items = state.items.map((product) => {
			return {
				...product,
				displayWeight: function() {
					const productWeight = product.weight ? product.weight : 0;
					const displayWeight = kgNumberFormat.format(productWeight)

					if ('0 kg' === displayWeight) {
						return gNumberFormat.format(productWeight * 1000);
					}

					return displayWeight;
				}(),
			};
		});
	}

	function convertToNumber(rawValue) {
		let value = toNumber(rawValue);
		return isFinite(value) ? value : 0;
	}

	function toBoolean(value) {
		if (typeof value === 'boolean') {
				return value;
		}

		if (typeof value === 'string') {
				const lowerValue = value.toLowerCase().trim();

				if (lowerValue === 'yes' || lowerValue === 'true') {
						return true;
				}

				if (lowerValue === 'no' || lowerValue === 'false') {
						return false;
				}

				// Handle positive numeric strings
				const numericValue = parseFloat(lowerValue);
				if (!isNaN(numericValue)) {
						return numericValue > 0; // Positive numeric strings return true
				}
		}

		if (typeof value === 'number') {
			return value > 0; // Any positive number is true, zero or negative numbers are false
	}

		return false; // For anything else, default to false
	}

	const initialState: Partial<BlockInitialState> = JSON.parse(block.dataset.initialState as string);

	const { state, callbacks } = store(storeNamespace, {
		state: {
			formChecks: {},
			formValues: {},
			...initialState,
			get totalWeight() {
				return state.items.reduce(
					(accumulator, currentValue) =>
						accumulator + (currentValue.quantity * currentValue.weight),
					0,
				);
			},
			get totalWeightInKgNumberFormat() {
				return kgNumberFormat.format(state.totalWeight);
			},
			get numSquareMeterInMeterNumberFormat() {
				return squareMeterNumberFormat.format(state.numSquareMeter);
			},
			get shrinkagePercentageInPercentageNumberFormat() {
				return percentageNumberFormat.format(state.shrinkagePercentage);
			},
			get hasInputValue() {
				return !!state.numRoomLength || !!state.numSquareMeter;
			},
			get thermoFormShowThermofloorSection(): boolean {
				if (state.hasTurntable) {
					return true;
				}

				if (state.collections.length > 1) {
					return true;
				}

				return false;
			},
			get thermoFormShowThermofloorHeading(): boolean {
				if (state.hasTurntable) {
					return true;
				}

				if (state.collections.length > 1) {
					return true;
				}

				return false;
			},
			get thermoFormShowNeedTurntableSection(): boolean {
				return state.hasTurntable && !!state.formValues.extraThermofloor;
			},
			get thermoFormShowLengthsSection(): boolean {
				return state.hasTurntable && !!state.formValues.extraThermofloor && !!state.formValues?.needTurntable
					|| !state.hasTurntable && !!state.formValues.extraThermofloor;
			},
			get thermoFormShowPipeLayingDirectionSection(): boolean {
				return state.hasTurntable && 'yes' === state.formValues?.needTurntable && 'yes' === state.formValues.lengthNextStep;
			},
			get thermoFormHidePipeLayingDirectionSection(): boolean {
				return !state.hasTurntable || 'no' === state.formValues?.needTurntable;
			},
			get thermoFormShowShoppingListSection(): boolean {
				return 'yes' === state.formValues.lengthNextStep
					&& (
						state.thermoFormHidePipeLayingDirectionSection
						|| !!state.formValues.pipeLayingDirection
					);
			},
			get thermoFormHasValidLengths(): boolean {
				if ('rectangular' === state.formValues.roomType) {
					return toBoolean(state.formValues.lengthA) && toBoolean(state.formValues.lengthB)
				}

				if ('l-shaped' === state.formValues.roomType) {
					return toBoolean(state.formValues.lengthA)
						&& toBoolean(state.formValues.lengthB)
						&& toBoolean(state.formValues.lengthC)
						&& toBoolean(state.formValues.lengthD);
				}

				if ('u-shaped' === state.formValues.roomType) {
					return toBoolean(state.formValues.lengthA)
						&& toBoolean(state.formValues.lengthB)
						&& toBoolean(state.formValues.lengthC)
						&& toBoolean(state.formValues.lengthD)
						&& toBoolean(state.formValues.lengthE);
				}

				return false;
			},
			get thermoFormLengthsSectionNexButtonHidden(): boolean {
				return !state.thermoFormShowLengthsSection
					|| state.thermoFormHasValidLengths && 'yes' === state.formValues.lengthNextStep;
			},
			thermoFormLengthAHidden: false,
			thermoFormLengthBHidden: false,
			get thermoFormLengthCHidden(): boolean {
				return 'rectangular' === state.formValues.roomType;
			},
			get thermoFormLengthDHidden(): boolean {
				return 'rectangular' === state.formValues.roomType;
			},
			get thermoFormRoomTypeIsRectangular(): boolean {
				return 'rectangular' === state.formValues.roomType;
			},
			get thermoFormRoomTypeIsLShaped(): boolean {
				return 'l-shaped' === state.formValues.roomType;
			},
			get thermoFormRoomTypeIsUShaped(): boolean {
				return 'u-shaped' === state.formValues.roomType;
			},
			get thermoFormLengthEHidden(): boolean {
				return 'rectangular' === state.formValues.roomType
					|| 'l-shaped' === state.formValues.roomType;
			},
			get submitButtonId() {
				if (state.isDeliveryTypeDownload) {
					return 'purchase-calculator-download-shopping-list-button';
				}

				if (state.isDeliveryTypeEmail) {
					return 'purchase-calculator-send-shopping-list-button';
				}

				return false;
			},
		},
		actions: {},
		callbacks: {
			initState: () => {
				prepareStateItems(state);
			},
			maybeRemoveValidationMessage(changedInputName) {
				if (changedInputName) {
					state.successMessage = '';
				}

				if (state.validationErrors[changedInputName]) {
					delete state.validationErrors[changedInputName];
				}

				if (isEmpty(state.validationErrors)) {
					state.validationMessage = '';
				}
			},
			onProductSelect: (event) => {
				const currentVariationId = parseInt(event.target.value, 10);

				if (currentVariationId) {
					selectVariation(currentVariationId);
				}

				if (state.currentVariationId !== currentVariationId) {
					state.currentVariationId = currentVariationId;
				}
			},
			onRoomLengthFieldChange: (event) => {
				state.numRoomLength = getAmountFromEvent(event);
				state.numSquareMeter = state.numRoomLength * (state.panelLength / 1000);
				callbacks.maybeRemoveValidationMessage(event.target.name);
			},
			onRoomLengthFieldInput: (event) => {
				callbacks.onRoomLengthFieldChange(event);
				validate(event.target);
			},
			onSquareMeterFieldChange: (event) => {
				state.numSquareMeter = getAmountFromEvent(event);
				state.numRoomLength = state.numSquareMeter > 0 ? Math.sqrt(state.numSquareMeter) : 0;
				callbacks.maybeRemoveValidationMessage(event.target.name);
			},
			onSquareMeterFieldInput: (event) => {
				callbacks.onSquareMeterFieldChange(event);
				validate(event.target);
			},
			onFieldInput: (event) => {
				callbacks.onFieldChange(event);
				validate(event.target);
			},
			onFieldChange: (event) => {
				event.preventDefault();
				const nameParts = event.target.name.split('.');
				const base = nameParts.shift();
				const path = !isEmpty(nameParts) ? nameParts.join('.') : '';

				if (!state[base] && path) {
					state[base] = {};
				}
				state[base] = path
					? set(clone(state[base]), path, event.target.value)
					: event.target.value;

				callbacks.maybeRemoveValidationMessage(event.target.name);
			},
			calculate: () => {
				state.isDeliveryTypeDownload = 'download' === state.deliveryType;
				state.isDeliveryTypeEmail = 'email' === state.deliveryType;

				const usingTurntable = state.formValues?.needTurntable === 'yes' && state.hasTurntable;

				if (
					state.productId !== state.currentVariationId
					|| state.currentUsingTurntable !== usingTurntable
				) {
					const collection = !!state.currentVariationId
						? state.collections.find((collection) => collection.product_id === state.currentVariationId)
						: state.collections[0];

					if (collection) {
						let items = collection.items;

						if (!usingTurntable) {
							items = items.filter((item) => !["per-meter-trun-area-inc-shrinkage", "per-meter-trun-area"].includes(item.type));
						}

						state.productId = collection.product_id;
						state.items = items;
						state.packageUnit = items[0].packageUnit;
						state.panelWidth = collection.panelWidth;
						state.panelLength = collection.panelLength;
						state.panelHeight = collection.panelHeight;
						state.hasTurntable = collection.hasTurntable;

						prepareStateItems(state);

						state.currentVariationId = state.productId;
						state.currentUsingTurntable = usingTurntable;
					}
				}

				if ('wall' === state.calculatorType) {
					state.numSquareMeter = state.numRoomLength * (state.panelLength / 1000);
					state.roomHeightInMeter = meterNumberFormat.format(state.panelLength / 1000);
				}

				if (['ceiling', 'floor'].includes(state.calculatorType)) {
					state.numRoomLength = Math.sqrt(state.numSquareMeter);
				}

				let numSquareMeterTurnArea = 0;
				let numTurnAreaLength = 0;

				if ('thermo_floor' === state.calculatorType) {
					const turnItem = state.items.find((item) => ["per-meter-trun-area-inc-shrinkage", "per-meter-trun-area"].includes(item.type));
					const turnItemWidthInMeter = convertToNumber(turnItem?.width) / 1000;
					const lengthA = convertToNumber(state.formValues?.lengthA);
					const lengthB = convertToNumber(state.formValues?.lengthB);
					const lengthC = convertToNumber(state.formValues?.lengthC);
					const lengthD = convertToNumber(state.formValues?.lengthD);
					const lengthE = convertToNumber(state.formValues?.lengthE);

					if ('rectangular' === state.formValues.roomType) {
						state.numSquareMeter = lengthA * lengthB;
						state.numRoomLength = (lengthA + lengthB) * 2;
						numTurnAreaLength = 'vertical' === state.formValues?.pipeLayingDirection
							? lengthA * 2
							: lengthB * 2;
					}

					if ('l-shaped' === state.formValues.roomType) {
						state.numSquareMeter = (lengthA * (lengthB + lengthD)) + (lengthC * lengthD);
						state.numRoomLength = (lengthA + lengthC + lengthB + lengthD) * 2;
						numTurnAreaLength = 'vertical' === state.formValues?.pipeLayingDirection
							? (lengthA + lengthC) * 2
							: (lengthB + lengthD) * 2;
					}

					if ('u-shaped' === state.formValues?.roomType) {
						state.numSquareMeter = (lengthA * (lengthD + lengthE))
							+ (lengthB * lengthE) + (lengthC * (lengthD + lengthE));
						state.numRoomLength = ((lengthA + lengthB + lengthC) * 2)
							+ ((lengthD + lengthE) * 2)
							+ (lengthD * 2);
						numTurnAreaLength = 'vertical' === state.formValues?.pipeLayingDirection
							? (lengthA + lengthB + lengthC) * 2
							: ((lengthD + lengthE) * 2) + (lengthD * 2);
					}

					numSquareMeterTurnArea = turnItemWidthInMeter * numTurnAreaLength;
				}

				const numRoomLength = convertToNumber(state.numRoomLength);
				const numSquareMeter = convertToNumber(state.numSquareMeter);
				const numTurnAreaLengthIncludingShrinkage = numTurnAreaLength * (100 + state.shrinkagePercentage) / 100;
				const numSquareMeterThermoArea = numSquareMeter - numSquareMeterTurnArea;
				const numSquareMeterTurnAreaIncludingShrinkage = numSquareMeterTurnArea * (100 + state.shrinkagePercentage) / 100;
				const numSquareMeterThermoAreaIncludingShrinkage = numSquareMeterThermoArea * (100 + state.shrinkagePercentage) / 100;

				state.numRoomLengthIncludingShrinkage = parseFloat(
					((numRoomLength / 100) * (100 + state.shrinkagePercentage)).toFixed(2),
				);

				state.numSquareMeterIncludingShrinkage = parseFloat(
					((numSquareMeter / 100) * (100 + state.shrinkagePercentage)).toFixed(2),
				);

				if ('wall' === state.calculatorType) {
					state.numPanels = (numRoomLength * 1000) / state.panelWidth;

					state.numPanelsIncludingShrinkage = (state.numRoomLengthIncludingShrinkage * 1000) / state.panelWidth;
				}

				if (['ceiling', 'floor'].includes(state.calculatorType)) {
					const panelCoverageInSquareMeter = (state.panelLength / 1000) * (state.panelWidth / 1000);

					state.numPanels = ceil(numSquareMeter / panelCoverageInSquareMeter);
					state.numPanelsIncludingShrinkage = ceil(state.numSquareMeterIncludingShrinkage / panelCoverageInSquareMeter);
				}

				state.items = state.items.map((product) => {
					let amountNeeded = 0;

					if (
						["per-meter-inc-shrinkage", "per-meter"].includes(product.type) &&
						product.amountPerMeter
					) {
						const numRoomLengthForCalc = 'per-meter' === product.type || numRoomLength <= product.amountPerMeter
							? numRoomLength
							: state.numRoomLengthIncludingShrinkage;

						amountNeeded = numRoomLengthForCalc / product.amountPerMeter;
					}

					if (
						["per-meter-trun-area-inc-shrinkage", "per-meter-trun-area"].includes(product.type) &&
						product.amountPerMeter
					) {
						const numRoomLengthForCalc = 'per-meter-trun-area' === product.type || numTurnAreaLength <= product.amountPerMeter
							? numTurnAreaLength
							: numTurnAreaLengthIncludingShrinkage;

						amountNeeded = numRoomLengthForCalc / product.amountPerMeter;
					}

					if ("per-panel" === product.type && product.amountPerPanel) {
						amountNeeded = state.numPanels * product.amountPerPanel;
					}

					if ("per-panel-inc-shrinkage" === product.type && product.amountPerPanel) {
						amountNeeded = state.numPanelsIncludingShrinkage * product.amountPerPanel;
					}

					if (
						["per-square-meter-inc-shrinkage", "per-square-meter"].includes(product.type) &&
						product.amountPerSquareMeter
					) {
						const unitCoverageInSquareMeter = 1 / product.amountPerSquareMeter;
						const numSquareMeterForCalc = 'per-square-meter' === product.type || numSquareMeter <= unitCoverageInSquareMeter
							? numSquareMeter
							: state.numSquareMeterIncludingShrinkage;

						amountNeeded = numSquareMeterForCalc * product.amountPerSquareMeter;
					}

					if (
						["per-square-meter-thermo-area-inc-shrinkage", "per-square-meter-thermo-area"].includes(product.type) &&
						product.amountPerSquareMeter
					) {
						const unitCoverageInSquareMeter = 1 / product.amountPerSquareMeter;
						const numSquareMeterForCalc = 'per-square-meter-thermo-area' === product.type || numSquareMeterThermoArea <= unitCoverageInSquareMeter
							? numSquareMeterThermoArea
							: numSquareMeterThermoAreaIncludingShrinkage;

						amountNeeded = numSquareMeterForCalc * product.amountPerSquareMeter;
					}

					if (
						["per-square-meter-turn-area-inc-shrinkage", "per-square-meter-turn-area"].includes(product.type) &&
						product.amountPerSquareMeter
					) {
						const unitCoverageInSquareMeter = 1 / product.amountPerSquareMeter;
						const numSquareMeterForCalc = 'per-square-meter-turn-area' === product.type || numSquareMeterTurnArea <= unitCoverageInSquareMeter
							? numSquareMeterTurnArea
							: numSquareMeterTurnAreaIncludingShrinkage;

						amountNeeded = numSquareMeterForCalc * product.amountPerSquareMeter;
					}

					if ('fixed' === product.type) {
						amountNeeded = 0 === state.numPanelsIncludingShrinkage ? 0 : toNumber(product.amountFixed);
					}

					let quantity = amountNeeded > 0 ? Math.ceil(amountNeeded / product.amountInPackage) : 0;

					const unit = quantity === 1 ? product.packageUnit : product.packageUnits;

					return {
						...product,
						quantity,
						quantityFormatted: quantityNumberFormat.format(quantity),
						unit,
					};
				});
			},
			onThermoFormChange: () => {
				// Autoselect if only one option.
				if (!!state.formValues.roomType && 1 === state.collections.length) {
					state.formValues.extraThermofloor = `${state.productId}`;
				}

				if (!state.formValues) {
					state.formValues = {} as any;
					state.oldFormValues = {} as any;
				}

				if (!state.thermoFormHasValidLengths) {
					state.formValues.lengthNextStep = null;
					state.formValues.pipeLayingDirection = null;
				}

				if (state.formValues?.extraThermofloor && state.currentVariationId !== state.formValues?.extraThermofloor) {
					state.currentVariationId = parseInt(state.formValues.extraThermofloor, 10);
				}

				/*
				const steps = [
					{
						name: "roomType",
					},
					{
						name: "extraThermofloor",
					},
					{
						name: "needTurntable",
					},
					{
						name: "lengthNextStep",
					},
					{
						name: "pipeLayingDirection",
					},
				];

				let changeFound = false;
				steps.forEach((step) => {
					const stepName = step.name;

					if (changeFound) {
						state.formValues[stepName] = '';
					}

					if (state.formValues[stepName] !== state.oldFormValues[stepName]) {
						changeFound = true;
					}
				})
				*/

				state.oldFormValues = state.formValues;

				// Interactivity api needs a true/false value for each checkbox or radio button.
				state.formChecks = clone(state.formChecks ? state.formChecks : {});

				const flatChecks: {[key: string]: boolean} = flatten(state.formChecks);

				Object.keys(flatChecks).forEach((key) => {
					set(state.formChecks, `${key}`, false);
				})

				const flatValues: {[key: string]: string} = flatten(state.formValues);

				Object.keys(flatValues).forEach((key) => {
					const value = flatValues[key];

					if (value) {
						state.formChecks = set(state.formChecks, `${key}.${value}`, true);
					}
				})
			},
			onFieldFocus: (event) => event.target.select(),
			onNumberFieldKeyDown: (event) =>
				["e", "E", "+", "-"].includes(event.key) && event.preventDefault(),
			onFormSubmit: (event) => {
				event.preventDefault();
				event.stopPropagation();

				state.successMessage = '';
				state.validationMessage = '';
				state.validationErrors = {};
				var isValidForm = (event.target as HTMLFormElement).checkValidity();

				if (!isValidForm) {
					return;
				}

				// const formElement = event.target;
				const productId = state.productId;
				const calculatorType = state.calculatorType;
				const items = state.items.map((product) => {
					return {
						name: product.name,
						quantity: product.quantity,
						productNumber: product.productNumber,
						nobbNumber: product.nobbNumber,
						displayDimensions: product?.displayDimensions ? product.displayDimensions : '',
						weight: product.weight,
						unit: product.unit,
						packageUnit: product.packageUnit,
					} as Partial<Product>
				});

				state.isLoading = true;

				const amount = state.calculatorType === "wall" ? state.numRoomLength : state.numSquareMeter;
				const amountUnit = state.calculatorType === "wall" ? "m" : "m2";
				const deliveryType = state.deliveryType ? state.deliveryType : 'download';
				const email = 'email' === state.deliveryType ? state.email : '';

				(window as any).dataLayer = (window as any).dataLayer || [];

				if ('download' === deliveryType) {
					axios
						.get(`${state.restUrlBase}download`, {
							params: {
								calculator_type: calculatorType,
								product_id: productId,
								amount,
								amount_unit: amountUnit,
								total_weight: state.totalWeight,
								trimming_percentage: state.shrinkagePercentage,
								items,
							},
							responseType: 'blob',
						})
						.then(function (response) {
							let fileName = "list.pdf";

							// Get the suggested file name from the content-disposition header.
							const contentDisposition = response.headers["content-disposition"];

							if (contentDisposition) {
								const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
								if (fileNameMatch.length === 2) {
									fileName = fileNameMatch[1];
								}
							}

							focusTrapInstance?.pause();
							fileDownload(response.data, fileName);
							focusTrapInstance?.unpause();

							(window as any).dataLayer.push({
								event: 'purchaseCalculatorSubmitted',
								purchaseCalculatorDeliveryType: deliveryType,
							});
						})
						.catch(function (error) {
							state.successMessage = '';

							if (error?.response?.data?.message) {
								state.validationMessage = error.response.data.message;
							} else if (error?.message) {
								state.validationMessage = error.message;
							}

							if (error?.response?.data?.errors) {
								state.validationErrors = error.response.data.errors;
							}
						})
						.finally(function() {
							state.isLoading = false;
						});
				}

				if ('email' === deliveryType) {
					axios
						.post(`${state.restUrlBase}email`, {
							calculator_type: calculatorType,
							product_id: productId,
							amount,
							amount_unit: amountUnit,
							email,
							total_weight: state.totalWeight,
							trimming_percentage: state.shrinkagePercentage,
							items,
						})
						.then(function (response) {
							if (response?.data?.message) {
								state.successMessage = response.data.message;
							} else {
								state.successMessage = 'Ok';
							}

							(window as any).dataLayer.push({
								event: 'purchaseCalculatorSubmitted',
								purchaseCalculatorDeliveryType: deliveryType,
							});
						})
						.catch(function (error) {
							state.successMessage = '';

							if (error?.response?.data?.message) {
								state.validationMessage = error.response.data.message;
							} else if (error?.message) {
								state.validationMessage = error.message;
							}

							if (error?.response?.data?.errors) {
								state.validationErrors = error.response.data.errors;
							}
						})
						.finally(function() {
							state.isLoading = false;
						});
				}
			},
		},
	});

	jQuery(".variations_form").on(
    "woocommerce_variation_select_change",
    function () {
      const button = document.getElementById('purchase-calculator-open-button') as HTMLButtonElement | null;

			if (button) {
				button.disabled = true;
			}
    },
  );

	jQuery( '.single_variation_wrap' ).on( 'show_variation', function( event, variation ) {
		state.currentVariationId = variation.variation_id;

		const button = document.getElementById('purchase-calculator-open-button') as HTMLButtonElement | null;

		if (button) {
			button.disabled = false;
		}
	});
}
